import React from 'react';
import { BlockInterpreter } from '../../../@core/components/interpreter/BlockInterpreter';

export const WizardInterpreter = (props) => {
  const { blocks } = props;

  console.log(blocks);

  return (
    <div className="row card">
      <div className="card-body">
        {blocks.map((block, i) => (
          <BlockInterpreter key={i} block={block} cardStyle="" />
        ))}
      </div>
    </div>
  );
};
